import { FieldTypeLink } from '@allesauto/utils/storyblok';
import React, { FC } from 'react';

import { AccordionFaqProps } from './';
import { AccordionItemProps } from '../accordion/accordion-item/AccordionItem';

type optionalProps = {
  items?: AccordionItemProps[];
  isMultiple?: boolean;
  hasShowMore?: boolean;
};

/**
 * Adapter that converts a 2-dim accordion model into a 3-dim FAQ Accordion model
 *
 * @example
 * {
 *   component: "faq-accordion",
 *   accordionHeading: "Headline",
 *   items: []
 * }
 *
 * becomes =>
 *
 * {
 *   component: "faq-accordion",
 *   accordionItems: [{
 *     accordionHeading: "Headline",
 *     items: []
 *   }]
 * }
 */
export const AccordionFaqAdapter = (
  AccordionFaq: FC<AccordionFaqProps & optionalProps>
) => {
  return function accordionFaqAdapter(
    props: AccordionFaqProps & optionalProps
  ) {
    const adaptedProps = {
      ...props,
      accordionItems: [
        {
          heading: props.accordionHeading,
          isMultiple: props.isMultiple,
          hasShowMore: props.hasShowMore,
          items: props.items as AccordionItemProps[],
        },
      ],
    };

    delete adaptedProps.isMultiple;
    delete adaptedProps.items;
    delete adaptedProps.accordionHeading;

    return <AccordionFaq {...(adaptedProps as AccordionFaqProps)} />;
  };
};
